import type { RoleSummary } from '@todo/shared';
import { get } from './client';

export const roleApi = {
  /** GET /api/roles - feeds the role dropdown on the add-person form. */
  list(): Promise<RoleSummary[]> {
    return get<RoleSummary[]>('/roles');
  },
};
